module.exports = __webpack_public_path__ + "static/media/mainpic.01a3e93c.jpg";